"use strict";
/**
 *
 * FormTag
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
var FormTag;
(function (FormTag) {
    FormTag[FormTag["DEFAULT_VALUES_CHANGE"] = 0] = "DEFAULT_VALUES_CHANGE";
    FormTag[FormTag["VALUES_CHANGE"] = 1] = "VALUES_CHANGE";
    FormTag[FormTag["VALUES_RESET"] = 2] = "VALUES_RESET";
    FormTag[FormTag["SUBMIT_ERROR_RESET"] = 3] = "SUBMIT_ERROR_RESET";
    FormTag[FormTag["CREATE_FIELD"] = 4] = "CREATE_FIELD";
    FormTag[FormTag["DISPOSE_FIELD"] = 5] = "DISPOSE_FIELD";
    FormTag[FormTag["FIELD_VALUE_CHANGE"] = 6] = "FIELD_VALUE_CHANGE";
    FormTag[FormTag["FIELD_VALUE_RESET"] = 7] = "FIELD_VALUE_RESET";
    FormTag[FormTag["SUBMIT"] = 8] = "SUBMIT";
    FormTag[FormTag["SUBMIT_WITH_DEFAULT_VALUES_CHANGE"] = 9] = "SUBMIT_WITH_DEFAULT_VALUES_CHANGE";
    FormTag[FormTag["FORM_TOGGLE_DISABLE_OR_READ_ONLY"] = 10] = "FORM_TOGGLE_DISABLE_OR_READ_ONLY";
})(FormTag = exports.FormTag || (exports.FormTag = {}));
